var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCkFooterHassleFreeDelievry21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.899 2.52c0-.65-.527-1.177-1.177-1.177H4.197c-.65 0-1.177.527-1.177 1.177v19.667a3.561 3.561 0 0 0-1.613.667c-1.548 1.098-1.914 3.553-.618 5.068l5.3 6.425c3.281 3.84 6.766 4.31 11.947 4.31 4.446 0 6.434.02 10.308-.863l3.773-.903c.612.855 1.583 1.408 2.675 1.408h1.859c1.847 0 3.349-1.583 3.349-3.528V24.252c0-1.857-1.37-3.383-3.101-3.517V2.52zm-6.857 19.839a9.322 9.322 0 0 0-8.177-.132c-.714.28-2.272 1.224-3.08 1.192h-5.44a3.276 3.276 0 0 0-3.273 3.273v.858l-.03-.032-3.886-4.217a3.584 3.584 0 0 0-.783-.64V10.987h9.63v4.314c0 .65.527 1.176 1.176 1.176h7.425c.65 0 1.177-.526 1.177-1.176v-4.314h9.764v9.748c-1.374.106-2.52 1.09-2.935 2.42l-1.568-.796zm-7.615-11.372v3.137h-5.071v-3.137h5.071zm2.354-2.353V3.696h9.764v4.938h-9.764zm-2.353 0h-5.072V3.696h5.072v4.938zm-7.425 0h-9.63V3.696h9.63v4.938zm3.075 27.657c-4.863 0-7.213-.078-10.173-3.442l-5.3-6.425c-.922-1.2.748-2.617 1.82-1.528l3.885 4.217c1.027 1.083 2.32 1.68 3.912 1.714h10.77a1.177 1.177 0 0 0 0-2.353H12.426v-1.782a.92.92 0 0 1 .92-.92h5.44c1.225.088 2.994-.935 4.073-1.411a6.98 6.98 0 0 1 6.12.097l2.465 1.252v8.923l-3.645.872c-3.58.82-5.735.786-9.72.786zm18.573-.345h-1.859c-.549 0-.996-.527-.996-1.175V24.252c0-.648.447-1.175.996-1.175h1.859c.549 0 .996.527.996 1.175v10.519c0 .648-.447 1.175-.996 1.175z",
    fill: "#121212",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCkFooterHassleFreeDelievry21);
export default __webpack_public_path__ + "static/media/icon-ck-footer-hassle-free-delievry-21.5bfbb49916064147caee3a42f452cb94.svg";
export { ForwardRef as ReactComponent };